var map = {
	"./aws-lambda.svg": 5730,
	"./dropdown-48x48-darker.svg": 1242,
	"./dropdown-48x48-simple-skeleton-text.svg": 9958,
	"./multiselect-48x48-simple-blue.svg": 6375,
	"./radio-48x48.svg": 448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1511;